module.exports = __webpack_public_path__ + "static/sky-ee90c8540e0dcf01680f57994a8b895a.png";